import { all } from 'redux-saga/effects';
import { pushApplicationSaga } from 'shared/components/Menu/module';
import { getArticleSaga } from 'shared/pages/Article/module';
import { getCatalogSaga, redirectToArticleSaga } from 'shared/pages/Catalog/module';
import { getCompanySaga, getCompanyBasedOnHostSaga } from 'shared/pages/Company/module';
import {
  decrementStepsCounterSaga,
  getDiagnosticSaga,
  getSymtomsFaultsCheckingProcessesFromSymptomSaga,
  getStepSaga,
  incrementStepsCounterSaga,
  pushStepIdToURLSaga,
  setActiveStepSaga,
  updateStepAnswerSaga,
} from 'shared/pages/Diagnostic/module';
import { getFormSaga, postFormSaga } from 'user/pages/Form/module';
import { getFormsSaga, setActiveFormSaga } from 'user/pages/HomePage/components/FormsList/module';
import { handleObjectClickSaga, getPortalComponentSaga } from 'user/pages/HomePage/module';
import { getProcessOverviewSaga } from 'user/pages/ProcessOverview/module';
import {
  getMurfyFormSaga,
  getMurfyFormTimeslotSaga,
  postMurfyFormSaga,
} from 'murfy/pages/MurfyBookingForm/module';
import {
  getSearchBarResultsSaga,
  handleResultSelectionSaga,
  redirectToResultsPageSaga,
} from 'user/components/SearchBar/module';
import { getPaymentDataSaga, postPaymentDataSaga } from 'murfy/pages/StripeCheckout/module';
import {
  getQuickBookingSettingsSaga,
  getQuickBookingTimeslotsSaga,
  getCouponSaga,
  postQuickBookingFormSaga,
  postSetupIntentSaga,
} from 'murfy/pages/QuickBooking/module';
import { getMurfyPagesSaga } from 'murfy/pages/MurfyPage/module';
import { getTutorielSaga } from 'user/pages/Tutoriel/module';
import { getThankYouSaga } from 'user/widgets/ThankYouWidget/module';
import {
  getCustomerFileSaga,
  getCustomerFileSuccessSaga,
  setVisitIdSaga,
} from 'murfy/pages/RepairReport/module';
import { getVisitHistorySaga } from 'murfy/pages/VisitHistory/module';

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    getProcessOverviewSaga(),
    getMurfyFormSaga(),
    getMurfyFormTimeslotSaga(),
    handleObjectClickSaga(),
    handleResultSelectionSaga(),
    setActiveFormSaga(),
    decrementStepsCounterSaga(),
    getArticleSaga(),
    getCatalogSaga(),
    getCompanySaga(),
    getCompanyBasedOnHostSaga(),
    getDiagnosticSaga(),
    getQuickBookingSettingsSaga(),
    getSymtomsFaultsCheckingProcessesFromSymptomSaga(),
    getFormSaga(),
    getFormsSaga(),
    getMurfyPagesSaga(),
    getPaymentDataSaga(),
    getPortalComponentSaga(),
    getSearchBarResultsSaga(),
    getStepSaga(),
    getThankYouSaga(),
    getCustomerFileSaga(),
    getCustomerFileSuccessSaga(),
    getVisitHistorySaga(),
    setVisitIdSaga(),
    getTutorielSaga(),
    incrementStepsCounterSaga(),
    postFormSaga(),
    postMurfyFormSaga(),
    postPaymentDataSaga(),
    postQuickBookingFormSaga(),
    pushApplicationSaga(),
    pushStepIdToURLSaga(),
    redirectToArticleSaga(),
    redirectToResultsPageSaga(),
    getQuickBookingTimeslotsSaga(),
    getCouponSaga(),
    setActiveStepSaga(),
    updateStepAnswerSaga(),
    postSetupIntentSaga(),
  ]);
}
